import React from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { all_routes } from "../../../Router/all_routes";
import { useEffect, useState } from "react";
import CheckRestauSelected from "../../components/SessionControl/checkrestauselected";
import SessionControl from "../../components/SessionControl/sessioncontrol";
import CountUp from "react-countup";
import axios from "axios";
import { base_api_url } from "../../../environment.jsx";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";


const Historique = () => {
        const route = all_routes;
        const MySwal = withReactContent(Swal);
        const navigate = useNavigate();
        const [loading, setLoading] = useState(false);
        const [CommandUsers, setCommandUsers] = useState([]);
        let devise = JSON.parse(localStorage.getItem("restaurant"))?.Restaurant?.devise || JSON.parse(localStorage.getItem("restaurant"))?.restaurant?.devise;
       
        useEffect(() => {
            fetchtCommandUsers();
        }, []);    
  
        const fetchtCommandUsers = async () => {
         setLoading(true);
         const token = JSON.parse(localStorage.getItem("user"))?.access_token;
         const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;
         const id_utilisateur = JSON.parse(localStorage.getItem("user"))?.id_utilisateur;
         try {
           let url = `${base_api_url}api/commandes/restaurant/${ideresto}/${id_utilisateur}`;
           const response = await axios.get(url, {
             headers: { Authorization: `Bearer ${token}` }
           });
           console.log("Les commandes de l'utilisateur :", response.data);
           
           // Handle successful responses (200, 201)
           if (response.status === 200 || response.status === 201) {
             const commandesData = response.data || [];
             setCommandUsers(commandesData);
     
             // Save user data
             localStorage.setItem("commandes", JSON.stringify(commandesData));
     
             // Show success notification only if tables are loaded
             if (commandesData.length <= 0) {
               // Show info notification if no tables found
               MySwal.fire({
                 icon: "info",
                 // title: "Aucune commande sur ce mois",
                 text: "Aucune commande trouvée pour ce restaurant. Créez votre première commande pour commencer.",
                 toast: true,
                 position: "bottom-end",
                 showConfirmButton: false,
                 timer: 3000,
                 timerProgressBar: true,
                 customClass: {
                   popup: "pixel-toast",
                 },
               });
             }
           }
         } catch (error) {
           console.log("Error fetching commandes:", error);

//            let errorTitle = "Erreur de chargement";
           let errorMessage = "Impossible de charger les commandes.";

           if (error.response) {
             const status = error.response.status;
             const errorData = error.response.data;
             
             switch (status) {
               case 401:
//                  errorTitle = "Session expirée";
                 errorMessage = "Votre session a expiré. Vous allez être redirigé vers la page de connexion.";
                 setTimeout(() => {
                   navigate(route.signin);
                 }, 2000);
                 break;
               case 400:
//                  errorTitle = "Aucun mois correspondant";
                 errorMessage = "Entrer un mois valide.";
                 break;
                 
               case 403:
//                  errorTitle = "Accès refusé";
                 errorMessage = "Vous n'avez pas les permissions nécessaires pour accéder aux commandes.";
                 break;
                 
               case 404:
//                  errorTitle = "Restaurant introuvable";
                 errorMessage = "Aucune commande trouvée pour ce restaurant ou le restaurant n'existe pas.";
                 break;
                 
               case 429:
//                  errorTitle = "Trop de tentatives";
                 errorMessage = "Trop de demandes en peu de temps. Veuillez patienter quelques instants.";
                 break;
                 
               case 500:
//                  errorTitle = "Erreur du serveur";
                 errorMessage = "Une erreur s'est produite sur le serveur. Veuillez actualiser la page.";
                 break;
                 
               case 503:
//                  errorTitle = "Service indisponible";
                 errorMessage = "Le service est temporairement indisponible. Veuillez réessayer plus tard.";
                 break;
                 
               default:
//                  errorTitle = `Erreur ${status}`;
                 errorMessage = errorData?.message || "Une erreur inattendue s'est produite lors du chargement des tables.";
             }
           } else if (error.request) {
//              errorTitle = "Problème de connexion";
             errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
           }
           
           // Show error notification
           MySwal.fire({
             icon: "error",
             // title: errorTitle,
             text: errorMessage,
             toast: true,
             position: "bottom-end",
             showConfirmButton: false,
             timer: 5000,
             timerProgressBar: true,
             customClass: {
               popup: "pixel-toast",
             },
           });
           
           // Set empty array on error to prevent UI issues
           setCommandUsers([]);
         } finally {
           setLoading(false);
         }
       };

       console.log("Les commandes de l'utilisataur:", CommandUsers);

     return (
    <div className="page-wrapper">
        <SessionControl
            storageKey="user"
            propsup="email"
            redirectTo={route.signin}
        />
        <CheckRestauSelected
            storageKey="user"
            redirectTo={route.Restaurants}
        />
        <div className="content">
            <div className="p-4">
                <h5 className="h3">Historique des serveurs</h5>
            </div>
             {loading ? (
                <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Chargement...</span>
                </div>
                </div>
            ) : (  
                <div className="content">
                    <div className="row">
                        <div className="col-xl-6 col-sm-6 col-lg-6 d-flex">
                            <div className="dash-widget w-100">
                                <div className="dash-widgetimg">
                                <span>
                                    <ImageWithBasePath
                                    src="assets/img/icons/dash1.svg"
                                    alt="img"
                                    />
                                </span>
                                </div>
                                <div className="dash-widgetcontent">
                                <h5>
                                    <CountUp 
                                    start={0} 
                                    end={CommandUsers?.total_des_ventes || 0} 
                                    duration={3} 
                                    suffix={devise} 
                                    />
                                </h5>
                                <h6>Chiffre d&apos;affaires </h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-sm-6 col-lg-6 d-flex">
                            <div className="dash-widget dash1 w-100">
                                <div className="dash-widgetimg">
                                <span>
                                    <ImageWithBasePath
                                    src="assets/img/icons/dash2.svg"
                                    alt="img"
                                    />
                                </span>
                                </div>
                                <div className="dash-widgetcontent">
                                <h5>
                                    <CountUp
                                    start={0}
                                    end={CommandUsers?.nombre_articles || 0}
                                    duration={3} // Duration in seconds
                                    />
                                </h5>
                                <h6>Nombre de plat vendu</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-12 col-sm-12 col-12 d-flex">
                    <div className="card flex-fill default-cover mb-4">
                        <div className="card-header d-flex align-items-center gap-4"
                            style={{ display: 'flex !important', justifyContent: 'flex-start' }}
                        >
                        <h5 className="card-title">les commandes les plus récentes</h5>
                        </div>
                        <div className="card-body">
                        <div className="table-responsive dataview">
                            <table className="table dashboard-recent-products">
                            <thead>
                                <tr>
                                <th>#Reference</th>
                                <th>Montant</th>
                                <th>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <div className="text-center py-4">
                                        <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Chargement...</span>
                                        </div>
                                    </div>
                                    ) : CommandUsers.length === 0 ? (
                                        <tr>
                                            <td colSpan="3" className="text-center">Aucune commande trouvée</td>
                                        </tr>                                
                                    ) : (
                                        CommandUsers.map((item) => (
                                            <tr key={item.id}>
                                                <td className="font-weight-bold">
                                                    {item.reference}
                                                </td>
                                                <td className="font-weight-bold">
                                                {item.prix} {devise}
                                                </td>
                                                <td className="font-weight-bold">{item.date_commande}</td>
                                            </tr>
                                        )))}
                            </tbody>
                            </table>
                        </div>
                        </div>
                    </div>
                    </div>
                    </div>
                </div>
            )}
        </div>
    </div>
  );
};

export default Historique;


